<template>
	<div class="w-100 flex-center flex-column">
		<!-- Flags and Currency Labels -->
		<p class="gradient-text text-center w-100 font-weight-regular mb-4">
			<span id="curr-one">
				{{ currOne }}
			</span>
			vs
			<span id="curr-two">
				{{ currTwo }}
			</span>
		</p>
		<div class="w-100 flex-center mb-8">
			<img
				:src="flagOne"
				alt="Flag One"
				style="width: 100px; border-top-right-radius: 0; border-bottom-right-radius: 0" />
			<img
				:src="flagTwo"
				alt="Flag Two"
				style="width: 100px; border-top-left-radius: 0; border-bottom-left-radius: 0" />
		</div>

		<!-- Swap Button -->
		<v-btn icon @click="swap">
			<v-icon>mdi-swap-horizontal</v-icon>
		</v-btn>

		<!-- Input Field with Calculation Display -->
		<div class="input-fields mt-4">
			<div class="flex-center">
				<v-text-field
					tile
					label="Amount"
					class="ppp-input"
					height="48"
					density="comfortable"
					width="180"
					variant="solo"
					hide-details
					v-model.number="amountCurrOne"
					type="number"
					@input="calculate"></v-text-field>
				<div
					class="flex-center pa-3"
					style="background-color: #fff; height: 48px; border-left: 1px solid #11111120">
					{{ currOne }}
				</div>
			</div>
		</div>

		<span class="white--text text-center w-100 mt-4 text-h5">
			{{ calculationFormula }}
		</span>

		<!-- Converted Amount Display -->
		<div class="converted-amount mt-7 white--text">
			<p class="white--text text-h5 text-center">
				Amount in {{ currTwo }}:
				<br />

				<span class="text-green">
					{{ convertedAmount }}
				</span>
			</p>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			country: {
				type: Object,
				required: true,
			},
		},
		data() {
			return {
				currOne: "USD",
				flagOne: "https://flagicons.lipis.dev/flags/4x3/us.svg",
				currTwo: "",
				flagTwo: "",
				amountCurrOne: 1,
				convertedAmount: "",
				calculationFormula: "",
			}
		},
		created() {
			this.currTwo = this.country.currency_code
			this.flagTwo = this.country.flag
			this.updateCalculationFormula()
		},
		mounted() {
			this.calculate()
		},
		methods: {
			swap() {
				// Swap the currency codes and flags
				;[this.currOne, this.currTwo] = [this.currTwo, this.currOne]
				;[this.flagOne, this.flagTwo] = [this.flagTwo, this.flagOne]
				// Reset the input and output amounts
				this.amountCurrOne = 1
				this.convertedAmount = ""
				// Update the calculation formula
				this.updateCalculationFormula()
			},
			calculate() {
				if (this.amountCurrOne != null && this.country.ppp != null) {
					if (this.currOne === "USD") {
						// Multiply amountCurrOne by PPP
						this.convertedAmount = (this.amountCurrOne * this.country.ppp).toFixed(2)
					} else {
						// Divide amountCurrOne by PPP
						this.convertedAmount = (this.amountCurrOne / this.country.ppp).toFixed(2)
					}
				} else {
					this.convertedAmount = ""
				}
			},
			updateCalculationFormula() {
				if (this.currOne === "USD") {
					this.calculationFormula = `× ${this.country.ppp}`
				} else {
					this.calculationFormula = `÷ ${this.country.ppp}`
				}
			},
		},
	}
</script>
